import { PaymentMethod } from '../enums/PaymentMethod';
import MilesAndMore from './MilesAndMore';
import { PaymentStatus } from './PaymentStatus';
import { WirecardTransactionType } from './WirecardTransactionType';

export default class Payment {
	// tslint:disable-next-line:variable-name
	_id: string;
	session: string;
	createdAt: Date;
	updatedAt: Date;
	orders: any = [];
	transactionType: WirecardTransactionType;
	status: PaymentStatus;
	method: PaymentMethod;
	sum: number;
	totalSum: number;
	tip = 0;
	wirecardTransactionId: string;
	requestId: string;
	paymentSignatureV2: string;
	merchantId: string;
	merchantName: string;
	creditorId: string;
	paymentMandat: string;
	currency: string;
	basicAuthorization: string;
	posMerchantReceipt: string;
	posCustomerReceipt: string;
	overwriteSessionsByApp = true;
	saveOcp = false;
	response: any = null;
	url: string;
	paypal: {
		orderId: string;
	};
	vrPayment: {
		checkoutId: string;
	};
	wpwlOptions: any;
	cardNumber?: string;
	milesAndMore?: MilesAndMore;
	posCheckoutReceipt?: string;
	neptingPayment?: { transactionId: string; request: NeptingPaymentRequest };
	worldlinePayment?: {
		paymentPage: string;
	};
	dataTransPayment?: {
		paymentId: string;
		redirectUrl?: string;
	};
}

export interface NeptingPaymentRequest {
	merchantId: string;
	merchantLabel: string;
	merchantPrivateData: string;
	description: string;
	email: string;
	name: string;
	urlSuccess: string;
	urlError: string;
	urlRefused: string;
	urlCancel: string;
	urlStatus: string;
	transactionType: string;
	locale: string;
	transactionId: string;
	amount: number;
	currencyCode: number;
	enrolment: number;
	mode: number;
	threedsChallengeIndicator: number;
	statusPage: number;
	signature: string;
}
